import Flex from 'components/Flex'
import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import styled from 'styled-components'
import { useSelector } from 'react-redux'

export const Wrapper = styled(Flex)`
  height: 100vh;
  width: 100%;
  background-color: #f6f6f6;
`

const SignInCard = styled.div`
  background-color: white;
  padding: 40px 32px;
  border-radius: 3px;
  max-width: 450px;
  width: 100%;
  margin: auto;
  box-shadow: 0px 2px 10px rgba(99, 116, 135, 0.2);
`
const { AUTH_URL } = process.env

const UserSignin = ({ token, SignIn }) => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
   const instituteDetails = useSelector(
      state => state?.auth?.instituteDetails
    )
    const accessLevel = instituteDetails?.instituteSubscription?.accessLevel
    console.log(accessLevel,'accessLevel1')
  const handleSignIn = data => {
    SignIn(data)
  }

  useEffect(() => {
    const authToken = searchParams.get('token')
    handleSignIn(authToken)
    if (!authToken && !token) {
      window.open(AUTH_URL, '_self')
    }
  }, [])

  useEffect(() => {
    if (token) {
      if (accessLevel === 1 || accessLevel === 3) {
        navigate('/tpoDashboard')
      } else {
        navigate('/students')
      }
    }
  }, [token])

  return (
    <Wrapper column>
      <SignInCard>Loading...</SignInCard>
    </Wrapper>
  )
}
export default UserSignin
